//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['id'],
  data() {
    return {
      loading: true
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$modal.hide('modal-stats')
    },
    loaded() {
      setTimeout(() => {
        this.loading = false
      }, 1500)
    },
    getURL(){
      return this.$config.BETTING_URL + '/stats/?event_id=' + this.id + '&lang=' + this.lang
    }
  }
}
